/**
 * Canonical brand hex values. Keep in sync with `--brand-*` in globals.css.
 * Use Tailwind classes (bg-brand-blue, text-bluetext, text-dark-green, etc.) in components when possible.
 * Import from here only for inline styles, CMS seeds, and programmatic color arrays.
 */
export const brandColors = {
  blue: '#B0D9FF',
  bluetext: '#002140',
  cream: '#FBFAF1',
  pink: '#F9B5FE',
  pinkWash: '#FCDCFF',
  tangerine: '#FFC68C',
  darkGreen: '#19805F',
  turquoise: '#69E1BB',
  turquoiseLight: '#8EE8CC',
} as const

export type BrandColor = (typeof brandColors)[keyof typeof brandColors]

/** Rotating badge backgrounds for blog categories and event locations. */
export const CATEGORY_BADGE_FALLBACK_COLORS = [
  brandColors.blue,
  brandColors.tangerine,
  brandColors.pinkWash,
] as const
